import React from 'react';

export const TextForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Content
        </label>
        <textarea
          value={specificAttrs.content || ''}
          onChange={(e) => handleChange('content', e.target.value)}
          rows={3}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px',
            fontFamily: 'inherit'
          }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Font Size (px)
          </label>
          <input
            type="number"
            value={specificAttrs.fontSize || 16}
            onChange={(e) => handleChange('fontSize', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Font Weight
          </label>
          <select
            value={specificAttrs.fontWeight || '400'}
            onChange={(e) => handleChange('fontWeight', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          >
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
            <option value="600">Semi-Bold</option>
            <option value="300">Light</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Text Align
          </label>
          <select
            value={specificAttrs.textAlign || 'left'}
            onChange={(e) => handleChange('textAlign', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
            <option value="justify">Justify</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Color
          </label>
          <input
            type="color"
            value={specificAttrs.color || '#000000'}
            onChange={(e) => handleChange('color', e.target.value)}
            style={{
              width: '100%',
              height: '34px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          />
        </div>
      </div>
    </div>
  );
};
